import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { MarkdownModule } from 'ngx-markdown';
import { firstValueFrom } from 'rxjs';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-developer-guide-api',
  standalone: true,
  imports: [CommonModule, MarkdownModule],
  templateUrl: './developer-guide-api.component.html',
  styleUrls: ['./developer-guide-api.component.scss']
})
export class DeveloperGuideApiComponent implements OnInit {
  markdownContent = '';
  isLoading = true;

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.loadMarkdownContent();
  }

  private async loadMarkdownContent(): Promise<void> {
    try {
      const markdownText = await firstValueFrom(this.http.get(`${environment.docsBaseUrl}/developer-guide-api.md`, { responseType: 'text' }));
      this.markdownContent = markdownText || '';
    } catch (e) {
      console.error('Error loading API developer guide:', e);
      this.markdownContent = '# Error\n\nError loading API developer guide content.';
    } finally {
      this.isLoading = false;
    }
  }
}
